/**
 * Cart Visual Sync
 * Asegura que todas las actualizaciones del carrito se reflejen visualmente de forma inmediata
 */

class CartVisualSync {
  constructor() {
    this.initEventListeners();
  }

  initEventListeners() {
    // Escuchar eventos de actualización del carrito
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:itemAdded', this.handleItemAdded.bind(this));

    // Escuchar el evento pub/sub del carrito
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.handlePubSubCartUpdate.bind(this));
    }
  }

  handleCartUpdate(event) {
    // Forzar actualización visual de todos los elementos relacionados con el carrito
    this.forceVisualUpdate();
  }

  handleItemAdded(event) {
    const cartData = event.detail.cartData;

    // Actualizar inmediatamente todos los contadores
    this.updateAllCartCounters(cartData.item_count);

    // Mostrar feedback visual
    this.showAddToCartFeedback();
  }

  handlePubSubCartUpdate(event) {
    if (event.cartData && event.cartData.item_count !== undefined) {
      this.updateAllCartCounters(event.cartData.item_count);
    }

    // Pequeño delay para asegurar que el DOM se actualice
    setTimeout(() => {
      this.forceVisualUpdate();
    }, 100);
  }

  updateAllCartCounters(itemCount) {
    // Actualizar contador principal del carrito
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      const countElements = cartIconBubble.querySelectorAll(
        '.cart-count-bubble span, .cart-count-bubble-text, [data-cart-count]'
      );
      countElements.forEach((element) => {
        element.textContent = itemCount || '0';
      });

      // Mostrar/ocultar bubble
      const bubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (bubble) {
        if (itemCount === 0) {
          bubble.style.display = 'none';
        } else {
          bubble.style.display = 'flex';
        }
      }
    }

    // Actualizar todos los elementos con data-cart-count
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach((element) => {
      element.textContent = itemCount || '0';
    });

    // Actualizar elementos con clases específicas de contador
    const cartCounters = document.querySelectorAll('.cart-count, .cart-counter, .header__cart-count');
    cartCounters.forEach((element) => {
      element.textContent = itemCount || '0';
    });
  }

  showAddToCartFeedback() {
    // Añadir clase temporal para mostrar feedback visual
    const cartIcon = document.querySelector('#cart-icon-bubble, .cart-icon, .header__cart');
    if (cartIcon) {
      cartIcon.classList.add('cart-updated');

      // Remover la clase después de la animación
      setTimeout(() => {
        cartIcon.classList.remove('cart-updated');
      }, 1000);
    }
  }

  forceVisualUpdate() {
    // Forzar reflow de elementos críticos del carrito
    const cartElements = document.querySelectorAll('cart-items, cart-drawer-items, .cart-icon, #cart-icon-bubble');
    cartElements.forEach((element) => {
      if (element) {
        element.offsetHeight; // Forzar reflow
      }
    });

    // Disparar evento de resize para actualizar layouts responsivos
    window.dispatchEvent(new Event('resize'));
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartVisualSync();
  });
} else {
  new CartVisualSync();
}
